/**
 * Theme Requirements Aggregation for Rr Living Landing Page
 * 
 * Extends the base landing-page theme requirements with Rr Living Landing Page specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-landing-page/requirements';

/**
 * Rr Living Landing Page component requirement overrides.
 * Add requirements for any override components here.
 */
const rrlivinglandingpageOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Rr Living Landing Page theme.
 * Inherits from landing-page theme and overrides with Rr Living Landing Page components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...rrlivinglandingpageOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
